import './locales/register'
import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'
import { paths } from '@/utils/path'
const Detail = lazy(() => import('./components/Detail'))

const List = lazy(() => import('./components/List'))
const TemplateDetail = lazy(() => import('./components/Templates/Detail'))

const MailerCampaignModule: RouteObject = {
    path: paths.mailerCampaign,
    children: [
        {
            path: '',
            element: <List />,
        },
        // Campaign routes
        {
            path: 'new',
            element: <Detail />,
        },
        {
            path: ':id',
            element: <Detail />,
        },
        {
            path: ':id/edit',
            element: <Detail />,
        },
        // Template routes
        {
            path: 'templates/new',
            element: <TemplateDetail />,
        },
        {
            path: 'templates/:id',
            element: <TemplateDetail />,
        },
        {
            path: 'templates/:id/edit',
            element: <TemplateDetail />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default MailerCampaignModule
